import './style.css'
import './app.ts'

if ('serviceWorker' in navigator && location.protocol === 'https:') {
	void navigator.serviceWorker.register('/sw.js')
}
